module.exports = __webpack_public_path__ + "img/logo.c4f20b43.png";